export default {
  header: {
    title: '💛 Giv drikkepenge til teamet',
    subtitle: '100 % går til holdet',
  },
  buttons: {
    other: 'Andet',
    none: 'Ingen',
  },
  summary_label: 'Drikkepenge',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} er den maksimale drikkepengesum',
      },
    },
  },
};
